import React, { useState } from "react";
import "./OverviewSection.css";
import Glossary from "../../components/AboutSection/Glossary/Glossary";
import DynamicButton from "../../components/AboutSection/DynamicButton";
import BodySection from "../../components/AboutSection/WhatWeStandFor/BodySection/BodySection";
import ImgBodySection from "../../components/AboutSection/WhatWeStandFor/BodySection/ImgBodySection";
import TimelineBodySection from "../../components/AboutSection/WhatWeStandFor/BodySection/TimelineBodySection";
import { Link } from "react-router-dom";
import ysf_dark_logo from "../../assets/yfs_logo_dark.svg";
import who from "../../assets/who.svg";
import timeline from "../../assets/timeline.svg";
import PricingTable from "../LandingPage/Pricing/PricingTable";

// import WhatWeStandFor from './WhatWeStandFor';

/**
 *
 * @returns the Overview to section of the about me page
 *
 */

const OverviewSection = () => {
  /**
   * This holds the current tab that is visible under the overview section
   * Uses useState to hold the component of the last button clicked, default is what we stand for
   */
  const [visibleComponent, setVisibleComponent] = useState("WhatWeStandFor");

  // Sets the visible compone to be the one of the button that is clicked
  const handleClick = (componentName) => {
    setVisibleComponent((prevComponent) =>
      prevComponent !== componentName ? componentName : prevComponent
    );
  };
  return (
    <>
      {/* // Entire Overview Section */}
      <div className="overview-section">
        {/* Logo */}
        <div className="about-section">
          <Link className="nav-link" to={"/"}>
            <img src={ysf_dark_logo} alt="Your Company Logo" />
          </Link>
        </div>
        <div className="buttons">
          {/* First Three buttons */}
          {/* <div className='button-row'> */}
          <DynamicButton
            text="What we stand for"
            onClick={() => handleClick("WhatWeStandFor")}
            isActive={visibleComponent === "WhatWeStandFor"}
          />
          <DynamicButton
            text="Glossary"
            onClick={() => handleClick("Glossary")}
            isActive={visibleComponent === "Glossary"}
          />
          <DynamicButton
            text="Payment Plan"
            onClick={() => handleClick("Payment")}
            isActive={visibleComponent === "Payment"}
          />

          {/* </div> */}
          {/* Second three buttons */}
          {/* <div className='button-row'> */}

          <DynamicButton
            text="Contact"
            onClick={() => handleClick("Contact")}
            isActive={visibleComponent === "Contact"}
          />
          <DynamicButton
            text="Testimonies"
            onClick={() => handleClick("Testimonies")}
            isActive={visibleComponent === "Testimonies"}
          />
          <DynamicButton
            text="Business Partners & Investors"
            onClick={() => handleClick("BusinessPartners")}
            isActive={visibleComponent === "BusinessPartners"}
          />

          {/* </div> */}
        </div>
      </div>

      <div className="horizontal-rule">
        <hr className="custom-hr"></hr>
      </div>

      {visibleComponent === "WhatWeStandFor" && <WhatWeStandFor />}
      {visibleComponent === "Glossary" && <Glossary />}
      {visibleComponent === "Payment" && <Payment />}

      {visibleComponent === "Contact" && <Contact />}
      {visibleComponent === "Testimonies" && <Testimonies />}
      {visibleComponent === "BusinessPartners" && <BusinessPartners />}
    </>
  );
};

const WhatWeStandFor = () => {
  return (
    <>
      <div className="mission">
        <BodySection
          title="Mission"
          header="Your better future Business"
          text="YFS is about sharing and understanding what our common purpose and responsibilities are. As a tool YFS makes a great and complex task managable"
        />
      </div>

      <div className="vision">
        <BodySection
          title="Vision"
          header="Your better future Business"
          text="YFS is about sharing and understanding what our common purpose and responsibilities are. As a tool YFS makes a great and complex task managable"
        />
      </div>

      <div className="history">
        <BodySection
          title="History"
          header="Your better future Business"
          text="YFS is about sharing and understanding what our common purpose and responsibilities are. As a tool YFS makes a great and complex task managable"
        />
      </div>

      <div className="who">
        <ImgBodySection title="Who" img={who} />
      </div>

      <div className="timeline">
        <TimelineBodySection title="Timeline" img={timeline} />
      </div>
    </>
  );
};

const Payment = () => {
  return (
    <div style={{ marginTop: "50px", paddingRight: "30px" }}>
      <PricingTable isAbout={true} />
    </div>
  );
};

const Contact = () => {
  return (
    <>
      <p>This is the contact section</p>
    </>
  );
};

const Testimonies = () => {
  return (
    <>
      <p>This is the testimonies section</p>
    </>
  );
};

const BusinessPartners = () => {
  return (
    <>
      <p>This is the business partners section</p>
    </>
  );
};

export default OverviewSection;
